export enum InvoiceDetailsPath {
  invoiceNumber = "invoiceNumber",
  accountNumber = "accountNumber",
}

export interface PathParams {
  [InvoiceDetailsPath.invoiceNumber]: string;
  [InvoiceDetailsPath.accountNumber]: string;
}
